<div
  class="d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main account-profile-change"
>
  <div class="header mt-1 mb-5 w-100">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        (click)="navigateBack()"
      />
      <h1 class="modal-title m-auto">{{ 'ACCOUNT_SETTING' | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="mb-5">
    <p class="text-center heading-one">{{ 'NEW_PROFILE_PICTURE' | translate }}</p>
    <p class="paragraph-text text-center">
      {{ 'PLEASE_UPLOAD_NEW_PROFILE_PICTURE' | translate }}
    </p>
  </div>

  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <div
      class="thumbnail sp-img-div"
      *ngIf="profileImageSrc"
      [ngClass]="{ 'no-border': profileImageSrc }"
    >
      <div class="parent image-container">
        <img
          alt="profile-picture"
          [src]="profileImageSrc"
          class="upload-img file-uploader"
        />
      </div>
    </div>

    <form [formGroup]="formGroup">
      <div class="form-group rounded-top form-container p-2" cdkScrollable>
        <mat-form-field
          class="add-photo-icon"
          appearance="fill"
          class="w-100"
          [ngClass]="
            formGroup?.controls?.photo?.errors?.invalidImage ? 'mb-3' : 'mb-2'
          "
        >
          <input
            matInput
            [placeholder]="'CHOOSE_IMAGE' | translate"
            formControlName="photo"
            readonly
          />
          <button
            mat-icon-button
            matSuffix
            tabindex="-1"
            type="button"
            (click)="addPhotoClickHandler()"
          >
            <img src="assets/svg/ico-add.svg" />
          </button>
          <mat-error>
            <span *ngIf="formGroup?.controls?.photo?.errors?.whitespace">{{
              'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate
            }}</span>
            <span *ngIf="formGroup?.controls?.photo?.errors?.invalidImage">{{
              'FORMAT_NOT_SUPPORTED' | translate
            }}</span>
            <span
              *ngIf="formGroup?.controls?.photo?.errors?.invalidImageSize"
              >{{ 'IMAGESIZE' | translate }}</span
            >
          </mat-error>
        </mat-form-field>
      </div>
    </form>
    <!-- this input tag will be hidden -->
    <input
      type="file"
      id="accountProfileUpload"
      name="accountProfileUpload"
      accept=".jpeg,.png,.jpg"
      class="d-none"
    />
  </div>
  <div class="row w-100 px-3">
    <div class="w-100">
      <button
        class="btn btn-danger update-btn px-3"
        [disabled]="!this.validImage"
        (click)="uploadImageHandler()"
      >
        {{ 'UPDATE' | translate }}
      </button>
    </div>
  </div>
</div>
